<template>
  <v-container fill-height>
    <v-row v-if="resultadosPersonal.length == 0" justify="center">
      <v-col cols="4">
        <v-card class="card" color="primary">
          <v-card-title class="justify-center font-weight-bold">Buscar personal</v-card-title>
          <v-card-text>
            <BaseInput v-model="busquedaPersonal.nombre" label="Nombre" />
            <BaseInput v-model="busquedaPersonal.segundoNombre" label="Segundo nombre" />
            <BaseInput v-model="busquedaPersonal.apaterno" label="Apellido paterno" />
            <BaseInput v-model="busquedaPersonal.amaterno" label="Apellido materno" />
            <BaseInput v-model="busquedaPersonal.curp" label="CURP" />
            <BaseInput v-model="busquedaPersonal.CUIP" label="CUIP" />
          </v-card-text>
          <v-card-actions class="justify-center pb-8">
            <v-container class="py-0">
              <v-row justify="center">
                <v-col cols="8" align="center">
                  <TextButton @click="triggerSearchPersonal()" :disabled="loading || emptyForm" :loading="loading">
                    Realizar búsqueda
                  </TextButton>
                </v-col>
              </v-row>
            </v-container>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col cols="12">
        <v-row>
          <v-col cols="4">
            <TextButton @click="RESET_BUSQUEDA_PERSONAL()">Realizar nueva búsqueda</TextButton>
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="4">
            <BaseInput label="Filtrar elementos" v-model="filtroPersonal"></BaseInput>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" lg="4" xl="3" v-for="personal in filteredPersonal" :key="personal.id">
        <v-card class="card" color="secondary" elevation="8">
          <v-card-title>
            <v-container>
              <v-row>
                <v-col cols="12" align="center">
                  <v-avatar rounded color="primary" size="80" v-if="!personal.foto">
                    <v-icon x-large color="secondary">mdi-account</v-icon>
                  </v-avatar>
                  <v-img
                    v-else
                    :src="personal.foto"
                    max-height="80"
                    max-width="80"
                    @error="personal.foto = null"
                  ></v-img>
                </v-col>

                <v-col cols="12" align="center">
                  <div class="text-h6 primary--text font-weight-bold">{{ personal.apaterno }}</div>
                  <div class="text-subtitle-1 primary--text">
                    {{ personal.amaterno + ' ' + personal.nombre + ' ' + personal.segundoNombre }}
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </v-card-title>
          <v-card-text>
            <div class="text-subtitle-1 font-weight-bold mb-2" align="center">Vigencias</div>
            <alerta-vigencia-cup-personal-component
              :vigencia-cup="personal.vigenciaCup"
            ></alerta-vigencia-cup-personal-component>
            <alerta-vigencia-c3-personal-component
              :vigencia-c3="personal.vigenciaEvaluacionC3"
            ></alerta-vigencia-c3-personal-component>
            <alerta-vigencia-competencias-basicas-personal-component
              :vigencia-competencias="personal.vigenciaCompetenciasBasicas"
            ></alerta-vigencia-competencias-basicas-personal-component>
            <alerta-vigencia-formacion-inicial-personal-component
              :vigencia-formacion="personal.vigenciaFormacionInicial"
            ></alerta-vigencia-formacion-inicial-personal-component>
          </v-card-text>
          <v-card-actions class="secondary darken-1">
            <v-container>
              <v-row>
                <v-col cols="12" align="right">
                  <v-tooltip
                    bottom
                    color="black"
                    v-if="hasAccessToFeature(perfil, FEATURES.REGISTRAR_TRAMITE_ADMINISTRATIVO)"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <IconRoundedButton
                        class="mr-2"
                        :elevation="8"
                        :to="{ name: 'enlace.registroTramiteAdministrativo', params: { id: personal.idPersonal } }"
                        icon="mdi-book-alert"
                        v-on="on"
                        v-bind="attrs"
                      ></IconRoundedButton>
                    </template>
                    <span>Registrar trámite administrativo</span>
                  </v-tooltip>
                  <v-tooltip bottom color="black">
                    <template v-slot:activator="{ on, attrs }">
                      <IconRoundedButton
                        :to="{ name: 'enlace.asignacionTurno', params: { id: personal.idPersonal } }"
                        icon="mdi-timetable"
                        :elevation="8"
                        class="mx-2"
                        v-on="on"
                        v-bind="attrs"
                      >
                      </IconRoundedButton>
                    </template>
                    <span>Asignación de turno</span>
                  </v-tooltip>
                  <v-tooltip bottom color="black">
                    <template v-slot:activator="{ on, attrs }">
                      <IconRoundedButton
                        :elevation="8"
                        :to="{
                          name: 'enlace.expedientePersonalSection',
                          params: { id: personal.idPersonal },
                        }"
                        icon="mdi-file-account"
                        v-on="on"
                        v-bind="attrs"
                      >
                      </IconRoundedButton>
                    </template>
                    <span>Ver expediente del personal</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-container>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import BaseInput from '../base/BaseInput.vue'
import TextButton from '../base/TextButton.vue'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import _ from 'lodash'
import AlertaVigenciaCupPersonalComponent from '../../components/personal/AlertaVigenciaCupPersonalComponent.vue'
import AlertaVigenciaC3PersonalComponent from '../../components/personal/AlertaVigenciaC3PersonalComponent.vue'
import AlertaVigenciaCompetenciasBasicasPersonalComponent from '../../components/personal/AlertaVigenciaCompetenciasBasicasPersonalComponent.vue'
import AlertaVigenciaFormacionInicialPersonalComponent from '../../components/personal/AlertaVigenciaFormacionInicialPersonalComponent.vue'
import IconRoundedButton from '../base/IconRoundedButton.vue'

export default {
  components: {
    BaseInput,
    TextButton,
    IconRoundedButton,
    AlertaVigenciaCupPersonalComponent,
    AlertaVigenciaC3PersonalComponent,
    AlertaVigenciaCompetenciasBasicasPersonalComponent,
    AlertaVigenciaFormacionInicialPersonalComponent,
  },
  data() {
    return {
      loading: false,
      filtroPersonal: '',
    }
  },
  computed: {
    ...mapGetters({
      perfil: 'getPerfil',
    }),

    ...mapGetters('personal', {
      resultadosPersonal: 'getPersonal',
      busquedaPersonal: 'getBusquedaPersonal',
    }),

    filteredPersonal: function () {
      return this.resultadosPersonal.filter((personal) => {
        return (
          this.getFullName(personal).toLowerCase().indexOf(this.filtroPersonal.toLowerCase()) >= 0 ||
          personal.CUIP.toLowerCase().indexOf(this.filtroPersonal.toLowerCase()) >= 0 ||
          personal.rfc.toLowerCase().indexOf(this.filtroPersonal.toLowerCase()) >= 0 ||
          personal.curp.toLowerCase().indexOf(this.filtroPersonal.toLowerCase()) >= 0
        )
      })
    },

    emptyForm() {
      if (
        this.busquedaPersonal.nombre === '' &&
        this.busquedaPersonal.segundoNombre === '' &&
        this.busquedaPersonal.apaterno === '' &&
        this.busquedaPersonal.amaterno === '' &&
        this.busquedaPersonal.curp === '' &&
        this.busquedaPersonal.CUIP === ''
      ) {
        return true
      } else return false
    },
  },
  methods: {
    ...mapActions('personal', ['searchPersonal']),
    ...mapMutations(['SET_SNACKBAR_MESSAGE']),
    ...mapMutations('personal', ['RESET_BUSQUEDA_PERSONAL']),

    async triggerSearchPersonal() {
      this.loading = true

      await this.searchPersonal(this.busquedaPersonal)
      if (this.resultadosPersonal.length == 0) {
        this.SET_SNACKBAR_MESSAGE('Búsqueda sin resultados.')
      }

      this.loading = false
    },
    hasFoto(personal) {
      const urlSinFoto =
        'https://edofza.eoninnovaction.com/CICG_SEG/ESTADO_FUERZA/Files/Fotografia/frente_AARD930724H214693851.jpg'
      return (
        personal.foto &&
        typeof personal.foto === 'string' &&
        personal.foto.trim() !== '' &&
        personal.foto !== urlSinFoto
      )
    },
    getFullName(personal) {
      return `${personal.apaterno} ${personal.amaterno} ${personal.nombre} ${personal.segundoNombre || ''}`.trim()
    },
  },
}
</script>

<style scoped>
.fab {
  position: fixed;
  bottom: 24px;
  right: 24px;
}
</style>
